module.exports = __webpack_public_path__ + "static/media/YandexMail.bbb0e6db.png";